module.exports = __webpack_public_path__ + "static/10-79dc76b21e5af9f496680b63c32aece7.jpg";